import { useContext } from 'react'
import { ThemeContext } from 'styled-components'
import { Theme } from './theme.types'

export function useTheme() {
  return useContext<Theme>(ThemeContext)
}
